import { Box, CircularProgress, Paper } from "@mui/material"
import type { FC, ReactNode } from "react"

import { PreferenceSectionHeader } from "./PreferenceSectionHeader"

interface CompanyPreferenceSectionProps {
  title: string
  onEdit: () => void
  canEdit: boolean
  editButtonTestId?: string
  children: ReactNode
  isLoading?: boolean
}

export const CompanyPreferenceSection: FC<CompanyPreferenceSectionProps> = ({
  title,
  onEdit,
  canEdit,
  editButtonTestId,
  children,
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <Box className='flex justify-center py-8'>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Paper elevation={0} className='flex flex-col gap-4 rounded-md border border-gray-400 p-6'>
      <PreferenceSectionHeader title={title} onEdit={onEdit} canEdit={canEdit} editButtonTestId={editButtonTestId} />
      {children}
    </Paper>
  )
}
